module.exports = __webpack_public_path__ + "public/img/applet-kaohe.9b003d3c.jpg";